<template>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <h5>Раді Вас бачити, {{ $page.props.user.name }} {{ $page.props.user.last_name }} в Адміністративній панелі цифрових сервісів.</h5>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'

export default {
    layout: AppLayout,
};
</script>
